import { Injectable, inject } from '@angular/core';

import { LocalStorageHelperService } from 'src/app/shared/services/local-storage-helper.service';

const EXPANDED_BRANCHES_KEY_PREFIX = 'selectCompany.expandedBranches.';
const MAX_EXPANDED_IDS = 200;

@Injectable({
  providedIn: 'root',
})
export class CompanyTreeExpansionService {
  private readonly localStorageHelper = inject(LocalStorageHelperService);

  read(userCompanyId: string): string[] {
    const key = this.storageKey(userCompanyId);
    if (!key) {
      return [];
    }

    try {
      const value = this.localStorageHelper.get(key);
      return this.isStringArray(value) ? value : [];
    } catch {
      return [];
    }
  }

  write(userCompanyId: string, ids: readonly string[]): void {
    const key = this.storageKey(userCompanyId);
    if (!key) {
      return;
    }

    const capped =
      ids.length > MAX_EXPANDED_IDS ? ids.slice(-MAX_EXPANDED_IDS) : [...ids];

    try {
      this.localStorageHelper.set(key, capped);
    } catch {
      return;
    }
  }

  prune(userCompanyId: string, id: string): void {
    const remaining = this.read(userCompanyId).filter(
      (storedId) => storedId !== id,
    );
    this.write(userCompanyId, remaining);
  }

  private storageKey(userCompanyId: string): string | null {
    if (typeof userCompanyId !== 'string' || userCompanyId.trim() === '') {
      return null;
    }

    return `${EXPANDED_BRANCHES_KEY_PREFIX}${userCompanyId}`;
  }

  private isStringArray(value: unknown): value is string[] {
    return (
      Array.isArray(value) && value.every((item) => typeof item === 'string')
    );
  }
}
